/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_MarketplacesInputs */

const tr_landing_nav_marketplaces = /** @type {(inputs: Landing_Nav_MarketplacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryerleri`)
};

const en_landing_nav_marketplaces = /** @type {(inputs: Landing_Nav_MarketplacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplaces`)
};

const de_landing_nav_marketplaces = /** @type {(inputs: Landing_Nav_MarketplacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplätze`)
};

const ru_landing_nav_marketplaces = /** @type {(inputs: Landing_Nav_MarketplacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркетплейсы`)
};

/**
* | output |
* | --- |
* | "Marketplaces" |
*
* @param {Landing_Nav_MarketplacesInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_nav_marketplaces = /** @type {((inputs?: Landing_Nav_MarketplacesInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_MarketplacesInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_nav_marketplaces(inputs)
	if (locale === "de") return de_landing_nav_marketplaces(inputs)
	if (locale === "ru") return ru_landing_nav_marketplaces(inputs)
	return tr_landing_nav_marketplaces(inputs)
});